import React, { useEffect, useState }  from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";

import assetify from "@quintype/framework/assetify";
import DesktopLogo from "../../../../assets/images/NL-new-logo.svg";
import HindiLogo from "../../../../assets/images/hindi-logo.png";
import MobileLogo from "../../atoms/icons/mobile-logo";

import "./publihser-logo.m.css";

export function Logo() {
  const [location, setLocation] = useState("");
  useEffect(() => {
    setLocation(global.location.host);
  }, []);

  const domainSlug = useSelector(state => get(state, ["qt", "domainSlug"], null));

  return (
    <React.Fragment>
      <div className="desktop-only ">
        {(location === "newslaundry-hindi-web.qtstage.io" || location === "hindi.newslaundry.com" )  && <img src={assetify(HindiLogo)} loading="lazy" alt="Newslaundry" width="156px" />  }
        {(location === "www.newslaundry.com" || location === "newslaundry-web.qtstage.io" ||  location === "newslaundry-beta.quintype.io" ||  location === "localhost:3000" ) && <img src={assetify(DesktopLogo)} loading="lazy" alt="Newslaundry" width="250px" />}
        {/* {domainSlug === null ? (
          <img src={assetify(DesktopLogo)} loading="lazy" alt="Newslaundry" width="250px" />
        ) : (
          <img src={assetify(HindiLogo)} loading="lazy" alt="Newslaundry" width="156px" />
        )} */}

      </div>
      <div className="mobile-only" styleName="logo-margin">
        <MobileLogo />
      </div>
    </React.Fragment>
  );
}
